import { useEffect, useState } from "react";
import { getCookies } from "cookies-next";
import axios from "axios";
import Swal from "sweetalert2";
import { config } from "../../data/config";
import BreadCrump from "../tools/breadcrump";
import HeaderOfPage from "../tools/headerOfPage";
import { useTranslation } from "react-i18next";
import changeUrl from "../../hoc/changeur";
import AutoTranslateButton from "../tools/AutoTranslateButton";

export default function ListArticles() {
  const { t } = useTranslation();

  const breadcrump = [
    { name: "Dashboard", url: "/dashboard" },
    { name: "Blog", url: "/dashboard/Blog" },
    { name: "List Article", url: null },
  ];

  const [key, setKey] = useState(1);
  const reloadItems = () => setKey((prev) => prev + 1);

  return (
    <div className="p-4 bg-gray-50 min-h-screen">
      <BreadCrump data={breadcrump} />
      <HeaderOfPage name="List Article" />
      <div className="grid grid-cols-1 sm:grid-cols-4 gap-6 mt-4">
        <div className="col-span-1">
          <NewBlogCategory reloaditem={reloadItems} />
        </div>
        <div className="col-span-3">
          <ListofBlog key={key} />
        </div>
      </div>
    </div>
  );
}

// -------------------- List of Blog --------------------
function ListofBlog() {
  const { t } = useTranslation();
  const cookie = getCookies();
  const [list, setList] = useState<any>(null);
  const [listgroup, setListGroup] = useState<any>(null);
  const [name, setName] = useState("");
  const [group, setGroup] = useState("");

  const loaddata = async (page = 1) => {
    try {
      const res = await axios.get(`${config.url}/v1/dashboard/post`, {
        headers: { Authorization: "Bearer " + cookie.token },
        params: { page, name, group },
      });
      setList(res.data.message);
    } catch (err) { }
  };

  const getGroups = async () => {
    try {
      const res = await axios.get(`${config.url}/v1/dashboard/bloggroup`, {
        headers: { Authorization: "Bearer " + cookie.token },
      });
      setListGroup(res.data.message);
    } catch (err) { }
  };

  const deleted = async (id: any) => {
    Swal.fire({
      title: t("Are you sure?"),
      text: t("Delete this Post!"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("Yes, delete it"),
    }).then(async (result) => {
      if (result.isConfirmed) {
        await axios.delete(`${config.url}/v1/dashboard/post/${id}`, {
          headers: { Authorization: "Bearer " + cookie.token },
        });
        loaddata(1);
      }
    });
  };

  useEffect(() => {
    loaddata(1);
    getGroups();
  }, []);

  const limitText = (text: string, maxLength: number) =>
    text.length > maxLength ? text.slice(0, maxLength) + "..." : text;

  return (
    <div className="bg-white p-4 rounded-lg shadow-md">
      {/* Filter Section */}
      <div className="grid grid-cols-1 sm:grid-cols-5 gap-4 mb-4">
        <input
          placeholder={t("Search by Slug")}
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="col-span-2 border border-gray-300 rounded px-3 py-2 focus:ring-2 focus:ring-blue-400 focus:outline-none"
        />
        <select
          className="col-span-2 border border-gray-300 rounded px-3 py-2 focus:ring-2 focus:ring-blue-400 focus:outline-none"
          onChange={(e) => setGroup(e.target.value)}
        >
          <option value="">{t("Select Group")}</option>
          {listgroup &&
            listgroup.map((g: any) => {
              const displayName = typeof g.name === 'object'
                ? (g.name.en || g.name.fa || g.name.ku || g.name.ar || g.name.tr || '')
                : g.name;
              return (
                <option key={g.id} value={g.id}>
                  {displayName}
                </option>
              );
            })}
        </select>
        <button
          className="col-span-1 bg-blue-500 hover:bg-blue-600 text-white font-semibold px-3 py-2 rounded"
          onClick={() => loaddata(1)}
        >
          {t("Filter")}
        </button>
      </div>

      {/* Blog Table */}
      <div className="overflow-x-auto" dir="rtl">
        <table className="min-w-full divide-y divide-gray-200 text-right">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-4 py-2 text-xs w-[100px]   text-right font-medium text-gray-500 uppercase">
                {t("Order")}
              </th>
              <th className="px-4 py-2 text-xs font-medium text-gray-500 uppercase">
                {t("Name")}
              </th>
              <th className="px-4 py-2 text-xs font-medium text-gray-500 uppercase">
                {t("Group")}
              </th>
              <th className="px-4 py-2 text-xs font-medium text-gray-500 uppercase">
                {t("Action")}
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {list?.docs?.map((item: any) => (
              <tr key={item.id} className="hover:bg-gray-50  items-center justify-center">
                <td className="px-4 py-2 flex gap-2 justify-items-start  pt-6 ">
                  <button>
                    <img src="/icons/arrowndown.svg" className="w-5" />
                  </button>
                  <button>
                    <img src="/icons/arrowup.svg" className="w-5" />
                  </button>
                </td>
                <td className="px-4 py-2">
                  <p className="font-medium">
                    {typeof item.name === 'object'
                      ? (item.name.en || item.name.fa || item.name.ku || item.name.ar || item.name.tr || '')
                      : item.name}
                  </p>
                  <p className="text-gray-400 text-xs">
                    {limitText(
                      typeof item.url === 'object'
                        ? (item.url.en || item.url.ku || item.url.fa || item.url.ar || item.url.tr || '')
                        : item.url || '',
                      30
                    )}
                  </p>
                </td>
                <td className="px-4 py-2">
                  {typeof item.toGroup?.name === 'object'
                    ? (item.toGroup.name.en || item.toGroup.name.fa || item.toGroup.name.ku || item.toGroup.name.ar || item.toGroup.name.tr || '')
                    : item.toGroup?.name}
                </td>
                <td className="px-4 py-2 flex gap-2">
                  <a href={`/dashboard/Blog/EditPost/${item.id}`}>
                    <img src="/icons/editgreen.svg" className="w-5" />
                  </a>
                  <button onClick={() => deleted(item.id)}>
                    <img src="/icons/delred.svg" className="w-5" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

type LanguageCode = 'ku' | 'fa' | 'en' | 'ar' | 'tr';

interface MultilingualField {
  ku: string;
  fa: string;
  en: string;
  ar: string;
  tr: string;
  [key: string]: string;
}

interface PostData {
  name: MultilingualField;
  url: MultilingualField;
  keywords: MultilingualField;
  description: MultilingualField;
  code: string;
  parent: string | null;
}

// Helper function to get display name from multilingual or string
const getDisplayName = (name: any): string => {
  if (!name) return '';
  if (typeof name === 'string') return name;
  if (typeof name === 'object') {
    return name.en || name.fa || name.ku || name.ar || name.tr || '';
  }
  return String(name);
};

// -------------------- New Blog Category --------------------
function NewBlogCategory({ reloaditem }: any) {
  const { t } = useTranslation();
  const cookie = getCookies();
  const [data, setData] = useState<PostData>({
    name: { ku: '', fa: '', en: '', ar: '', tr: '' },
    url: { ku: '', fa: '', en: '', ar: '', tr: '' },
    keywords: { ku: '', fa: '', en: '', ar: '', tr: '' },
    description: { ku: '', fa: '', en: '', ar: '', tr: '' },
    code: '',
    parent: null,
  });
  const [list, setList] = useState<any>(null);
  const [error, setError] = useState<any>(null);
  const [key, setKey] = useState(1);
  const [saving, setSaving] = useState(false);
  const [activeLang, setActiveLang] = useState<LanguageCode>('en');
  const languages: Array<{ code: LanguageCode; label: string }> = [
    { code: 'ku' as LanguageCode, label: 'Kurdish' },
    { code: 'fa' as LanguageCode, label: 'فارسی' },
    { code: 'en' as LanguageCode, label: 'English' },
    { code: 'ar' as LanguageCode, label: 'العربية' },
    { code: 'tr' as LanguageCode, label: 'Türkçe' }
  ];

  // Helper function to safely access multilingual fields
  const getMultilingualValue = (field: MultilingualField, lang: LanguageCode): string => {
    return field[lang] || '';
  };

  const setName = (name: string) => {
    const updatedName = {
      ...data.name,
      [activeLang]: name
    };

    const updatedUrl = { ...data.url };
    updatedUrl[activeLang] = String(changeUrl(name)); // Slug generated for active language

    setData((prev: PostData) => ({
      ...prev,
      url: updatedUrl,
      name: updatedName
    }));
  };

  const save = async () => {
    setError(null);
    setSaving(true);
    try {
      await axios.post(`${config.url}/v1/dashboard/post`, data, {
        headers: { Authorization: "Bearer " + cookie.token },
      });
      Swal.fire({
        icon: 'success',
        title: t('Success'),
        text: t('Post added successfully'),
        timer: 1500,
        showConfirmButton: false
      });
      // Reset form
      setData({
        name: { ku: '', fa: '', en: '', ar: '', tr: '' },
        url: { ku: '', fa: '', en: '', ar: '', tr: '' },
        keywords: { ku: '', fa: '', en: '', ar: '', tr: '' },
        description: { ku: '', fa: '', en: '', ar: '', tr: '' },
        code: '',
        parent: null,
      });
      reloaditem();
      setKey((prev) => prev + 1);
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: t('Error'),
        text: err.response?.data?.message || t('Failed'),
      });
      setError(err.response?.data?.message?.errors || null);
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    axios
      .get(`${config.url}/v1/dashboard/bloggroup`, {
        headers: { Authorization: "Bearer " + cookie.token },
      })
      .then((res) => setList(res.data.message));
  }, []);

  const inputStyle =
    "w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 focus:outline-none bg-white text-gray-900";

  return (
    <div className="bg-white rounded-xl shadow-sm p-6" dir="rtl">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">{t("New Post")}</h3>

      {error && (
        <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
          <p className="text-sm text-red-800">{error}</p>
        </div>
      )}

      <form className="space-y-4">
        {/* Language Selector */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            زبان
          </label>
          <div className="flex gap-2 flex-wrap">
            {languages.map((lang) => (
              <button
                key={lang.code}
                type="button"
                onClick={() => setActiveLang(lang.code)}
                className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-colors ${activeLang === lang.code
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
              >
                {lang.label}
              </button>
            ))}
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Code <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={data.code}
            className={inputStyle}
            placeholder="مثال: POST001"
            onChange={(e) => setData((prev: PostData) => ({ ...prev, code: e.target.value }))}
            required
          />
          <p className="mt-1 text-xs text-gray-500">کد یکتای پست (به انگلیسی و بدون فاصله)</p>
        </div>

        <div>
          <div className="flex items-center justify-between mb-2">
            <label className="block text-sm font-medium text-gray-700">
              {t("Name")} ({languages.find(l => l.code === activeLang)?.label}) <span className="text-red-500">*</span>
            </label>
            <AutoTranslateButton
              sourceText={data.name.en}
              targetLang={activeLang}
              onTranslated={(text) => setData((prev: PostData) => ({ ...prev, name: { ...prev.name, [activeLang]: text }, url: { ...prev.url, [activeLang]: String(changeUrl(text)) } }))}
            />
          </div>
          <input
            type="text"
            value={getMultilingualValue(data.name, activeLang)}
            className={inputStyle}
            placeholder="نام پست را وارد کنید"
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            URL ({languages.find(l => l.code === activeLang)?.label}) <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={getMultilingualValue(data.url, activeLang)}
            className={inputStyle}
            placeholder="slug"
            onChange={(e) => setData((prev: PostData) => ({
              ...prev,
              url: {
                ...prev.url,
                [activeLang]: e.target.value
              }
            }))}
            required
          />
          <p className="mt-1 text-xs text-gray-500">به صورت خودکار از نام تولید می‌شود</p>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {t("Group")}
          </label>
          <select
            className={inputStyle}
            onChange={(e) => setData((prev: PostData) => ({ ...prev, parent: e.target.value || null }))}
          >
            <option value="">{t("Choose Group")}...</option>
            {list?.map((g: any) => (
              <option key={g.id} value={g.id}>
                {getDisplayName(g.name)}
              </option>
            ))}
          </select>
        </div>

        <div>
          <div className="flex items-center justify-between mb-2">
            <label className="block text-sm font-medium text-gray-700">
              {t("Keywords")} ({languages.find(l => l.code === activeLang)?.label})
            </label>
            <AutoTranslateButton
              sourceText={data.keywords.en}
              targetLang={activeLang}
              onTranslated={(text) => setData((prev: PostData) => ({ ...prev, keywords: { ...prev.keywords, [activeLang]: text } }))}
            />
          </div>
          <textarea
            rows={3}
            value={getMultilingualValue(data.keywords, activeLang)}
            className={inputStyle}
            onChange={(e) => setData((prev: PostData) => ({
              ...prev,
              keywords: {
                ...prev.keywords,
                [activeLang]: e.target.value
              }
            }))}
            placeholder="کلمات کلیدی (با کاما جدا کنید)"
          />
        </div>

        <div>
          <div className="flex items-center justify-between mb-2">
            <label className="block text-sm font-medium text-gray-700">
              {t("Description")} ({languages.find(l => l.code === activeLang)?.label})
            </label>
            <AutoTranslateButton
              sourceText={data.description.en}
              targetLang={activeLang}
              onTranslated={(text) => setData((prev: PostData) => ({ ...prev, description: { ...prev.description, [activeLang]: text } }))}
            />
          </div>
          <textarea
            rows={4}
            value={getMultilingualValue(data.description, activeLang)}
            className={inputStyle}
            onChange={(e) => setData((prev: PostData) => ({
              ...prev,
              description: {
                ...prev.description,
                [activeLang]: e.target.value
              }
            }))}
            placeholder="توضیحات پست"
          />
        </div>

        <button
          type="button"
          onClick={save}
          disabled={saving || !getMultilingualValue(data.name, activeLang) || !data.code || !getMultilingualValue(data.url, activeLang)}
          className="w-full inline-flex items-center justify-center gap-x-2 px-6 py-2.5 text-sm font-medium rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none transition-colors"
        >
          {saving ? (
            <>
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
              در حال ذخیره...
            </>
          ) : (
            <>
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              {t("Save")}
            </>
          )}
        </button>
      </form>
    </div>
  );
}
